<app-breadcrumb></app-breadcrumb>
<div class="container mt-4 ">
  <mat-card class="mat-elevation-z8 p-4 cardWithShadow">
    <h3 class="text-center mb-3" style="margin-bottom: 30px; margin-top: 20px;">{{ 'Evaluation.QRGenerator' | translate
      }}</h3>


    <div class="row">
      <!-- 🔹 First Dropdown: Evaluation Subject Selection -->
      <div class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'Evaluation.SelectItem' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedTable" (selectionChange)="onTableSelect($event)" [disabled]="loading">
            <mat-option *ngFor="let table of allTables" [value]="table">
              {{ isArabic && table.nameAr ? table.nameAr : table.nameEn }}
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="allTables.length === 0">{{ 'Evaluation.NoEvaluationSubjectsAvailable' | translate
            }}</mat-hint>
        </mat-form-field>
      </div>

      <!-- 🔹 Second Dropdown: Subject Objects Selection -->
      <div class="col-lg-6">
        <mat-form-field appearance="outline" class="w-100" *ngIf="selectedTable">
          <mat-label>{{ 'Evaluation.SelectItem' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedName" (selectionChange)="onNameSelect($event)"
            [disabled]="loading || fetchedNames.length === 0">
            <mat-option *ngFor="let name of fetchedNames" [value]="name">
              {{ isArabic && name.nameAr ? name.nameAr : name.nameEn }}
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="fetchedNames.length === 0 && selectedTable">
            {{ 'Evaluation.NoItemsAvailableForThisSubject' | translate }}
          </mat-hint>
        </mat-form-field>
      </div>
    </div>

    <!-- 🔹 Loading Indicator -->
    <div class="row" *ngIf="loading">
      <div class="col-12 text-center">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading...</p>
      </div>
    </div>

  </mat-card>
</div>

<!-- QR Code Section -->


<div class="container mt-4">
  <div class="justify-content-center align-items-center d-flex" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <mat-card class="mat-elevation-z8 p-4 text-center" *ngIf="!loading && qrCodeImageUrl">
    <!-- QR Code Display -->
    <ng-container>
      <div class="d-flex flex-column justify-content-center align-items-center ">
        <img [src]="qrCodeImageUrl" alt="QR Code" class="img-fluid" style="width: 250px; height: 250px;" />
      </div>

      <input type="text" matInput disabled [value]="encryptedurl" />
      <button mat-raised-button color="accent" (click)="printQr()">
        <mat-icon>print</mat-icon> {{ 'Shared.Print' | translate }}
      </button>
    </ng-container>
  </mat-card>
</div>